import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { Container, Dropdown, Modal, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import cookies from "js-cookie";
import classNames from "classnames";
import ReactHtmlParser from "react-html-parser";
import { format } from "timeago.js";
import Marquee from "react-fast-marquee";
import { BsTwitterX } from "react-icons/bs";

// Components & Services
import Search from "./common/Search";
import Sidebar from "./common/Sidebar";
import StickyMenu from "./common/StickyMenu";
import MobileMenu from "./common/MobileMenu";
import { Styles } from "./styles/headerTnpa.js";
import RenderOnAnonymous from "../pages/account/RenderOnAnonymous";
import RenderOnAuthenticated from "../pages/account/RenderOnAuthenticated";
import RenderOnRole from "../pages/account/RenderOnRole";
import UserActionLogin from "../pages/account/UserActionLogin";
import UserService from "../services/UserService";
import service from "../services/service";

// Assets
import logoNew from "../assets/images/tnpa-Footer-logo.png";
import languages from '../assets/lang/languages.json';

function HeaderTNP() {
  const { t } = useTranslation();
  const history = useHistory();
  const [announcementData, setAnnouncementData] = useState([]);
  const [marqueeData, setMarqueeData] = useState([]);
  const [getAnnouncmentModal, setAnnouncementModal] = useState(false);
  const [announcementData1, setAnnouncementData1] = useState({ title: "", body: "", date: "" });

  const currentLanguageCode = cookies.get("i18next") || "en";
  const currentLanguage = languages.find((l) => l.code === currentLanguageCode);

  useEffect(() => {
    UserService.generateToken();
    document.body.dir = currentLanguage?.dir ?? "ltr";
    document.title = t("app_title");

    service.MarqueeByCurrentDataToPublishUpTo().then(res => setMarqueeData(res.data)).catch(console.error);
    service.AnnouncementByCurrentDataToPublishUpTo().then(res => setAnnouncementData(res.data)).catch(console.error);
  }, [currentLanguage, t]);

  const afterLogout = () => {
    service.updateUserActionDetails(UserService.getUserid(), UserService.getSessionId());
    UserService.doLogout();
    history.push("/");
  };

  const AnnouncementModal = (title, body, date) => {
    setAnnouncementData1({ title, body, date });
    setAnnouncementModal(true);
  };

  return (
    <Styles>
      {/* LAYER 1: Utility Bar */}
      <div className="top-utility-row desktop-only">
        <Container className="h-100">
          <div className="d-flex justify-content-between align-items-center h-100">
            <div className="contact-links d-flex align-items-center">
              <span><i className="las la-phone"></i> {t("call_us_phone")}</span>
              <span className="separator mx-3"></span>
              <span><i className="las la-envelope"></i> {t("enquiry_us_id")}</span>
            </div>

            <div className="right-tools d-flex align-items-center">
              <div className="social-box me-4 d-flex align-items-center">
                <a href="https://www.facebook.com/pages/Tamilnadu%20Police%20Academy/250289641769332" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f"></i></a>
                <a href="https://x.com/tnpoliceoffl" target="_blank" rel="noopener noreferrer"><BsTwitterX /></a>
                <a href="https://www.youtube.com/@TNPAIGP" target="_blank" rel="noopener noreferrer"><i className="fab fa-youtube"></i></a>
              </div>

              <Dropdown className="lang-selector-modern px-2 capitalize">
                <Dropdown.Toggle variant="none">
                  <i className="las la-globe"></i> {currentLanguage?.name} <i className="las la-angle-down"></i>
                </Dropdown.Toggle>
                <Dropdown.Menu align="end">
                  {languages.map(({ code, name, is_enabled }) => (
                    is_enabled && (
                      <Dropdown.Item
                        key={code}
                        onClick={() => i18next.changeLanguage(code)}
                        className={classNames({ 'active-lang': currentLanguageCode === code })}
                      >
                        {name}
                      </Dropdown.Item>
                    )
                  ))}
                </Dropdown.Menu>
              </Dropdown>

              <div className="auth-cluster ms-4 d-flex align-items-center">
                <RenderOnAnonymous>
                  <Link onClick={() => UserService.doLogin()} to="#" className="auth-link">
                    <i className="las la-user-circle"></i> {t("log_in")}
                  </Link>
                </RenderOnAnonymous>
                <RenderOnAuthenticated>
                  <div className="user-action-wrapper"><UserActionLogin /></div>
                  <Link onClick={afterLogout} to="#" className="auth-link ms-3">
                    <i className="las la-sign-out-alt"></i> {t("log_out")}
                  </Link>
                </RenderOnAuthenticated>
              </div>
            </div>
          </div>
        </Container>
      </div>

      {/* LAYER 2: Main Header */}
      <header className="main-nav-row desktop-only">
        <Container className="position-relative">
          <div className="nav-wrapper">

            <div className="floating-branding">
              <Link to="/">
                <div className="logo-shield">
                  <img src={logoNew} alt="TNPA" />
                </div>
                <div className="logo-text">
                  <h1 className="brand-gradient">TNPA-eKalvi</h1>
                  <p>TN POLICE ACADEMY</p>
                </div>
              </Link>
            </div>

            <nav className="central-navigation">
              <ul className="nav-menu-list">
                <li><Link to="/">{t("home")}</Link></li>
                <li><Link to="/about">{t("about_us")}</Link></li>

                {/* COURSES DROPDOWN AS GRID */}
                <li className="nav-dropdown-item">
                  <Link to="#">{t("courses")} <i className="las la-angle-down"></i></Link>
                  <ul className="sub-menu grid-menu">
                    <RenderOnAuthenticated>
                      <RenderOnRole roles={['instructor']}>
                        <li><Link to="/CourseStructureDrive">{t('course_Content_Drive')}</Link></li>
                        <li><Link to="/add-course-category">{t('course_Category')}</Link></li>
                        <li><Link to="/CreateCourse">{t('create_course')}</Link></li>
                        <li><Link to="/ViewCourses">{t('authored_Courses')}</Link></li>
                        <li><Link to="/clone-course">{t('clone_course')}</Link></li>
                      </RenderOnRole>
                      <RenderOnRole roles={['learner']}>
                        {/* <li><Link to="/user-grid">{t('my_courses')}</Link></li> */}
                      </RenderOnRole>
                    </RenderOnAuthenticated>
                    <li><Link to="/course-grid">{t('all_courses')}</Link></li>
                  </ul>
                </li>

                <li className="nav-dropdown-item">
                  <Link to="#">{t("e-library")} <i className="las la-angle-down"></i></Link>
                  <ul className="sub-menu">
                    <RenderOnAuthenticated>
                      <RenderOnRole roles={['instructor']}>
                        <li><Link to="/view-library">{t('published_book')}</Link></li>
                        <li><Link to="/create-library">{t('create_library')}</Link></li>
                      </RenderOnRole>
                    </RenderOnAuthenticated>
                    <li><Link to="/library-content">{t("all_book")}</Link></li>
                  </ul>
                </li>

                <RenderOnAuthenticated>
                  <li className="nav-dropdown-item">
                    <Link to="#">{t("dashboard")} <i className="las la-angle-down"></i></Link>
                    <ul className="sub-menu">
                      {UserService.hasRole(['instructor']) ? (
                        <>
                          <li><Link to="/instructor-dashboard">{t('instructor_Dashborad')}</Link></li>
                          {/* <li><a href={`${process.env.PUBLIC_URL}/extensions/calendar`}>{t('learner_Dashboard')}</a></li> */}
                          <li><a href={`${process.env.PUBLIC_URL}/dashboard`}>{t('learner_Dashboard')}</a></li>
                        </>
                      ) : UserService.hasRole(['admin']) ? (
                        <li><Link to="/AdminDashBoard">{t('admin_Dashborad')}</Link></li>
                      ) : (
                        <>
                          {/* <li><a href={`${process.env.PUBLIC_URL}/extensions/calendar`}>{t('learner_Dashboard')}</a></li> */}
                          <li><a href={`${process.env.PUBLIC_URL}/dashboard`}>{t('learner_Dashboard')}</a></li>
                        </>
                      )}
                    </ul>
                  </li>
                </RenderOnAuthenticated>

                <li><Link to="/contact">{t("contact")}</Link></li>
              </ul>
            </nav>

            <div className="action-meta">
              {/* ANNOUNCEMENT DROPDOWN (HOVER FIXED VIA CSS) */}
              <div className="notif-wrapper dropdown">
                <div className="notif-trigger">
                  <i className="tnpa-bell las la-bell"></i>
                  {announcementData.length > 0 && <span className="count-badge">{announcementData.length}</span>}
                </div>
                <ul className="dropdown-menu announcement-drop">
                  <div className="drop-header">{t('announcements')}</div>
                  {announcementData.length > 0 ? (
                    announcementData.map((data, i) => (
                      <li key={i} onClick={() => AnnouncementModal(data.title, data.body, format(data.publihFrom))}>
                        <div className="anno-title">{data.title}</div>
                        <div className="anno-date">{format(data.publihFrom)}</div>
                      </li>
                    ))
                  ) : (
                    <li className="text-center py-3 text-muted">No New Announcements</li>
                  )}
                </ul>
              </div>

              <RenderOnAnonymous>
                <Link to="/registration" className="cta-btn-gold">{t("register")}</Link>
              </RenderOnAnonymous>

              <div className="sidebar-toggle-wrapper">
                <Sidebar />
              </div>
            </div>

          </div>
        </Container>
      </header>

      {/* LAYER 3: Ticker */}
      <div className="ticker-row desktop-only">
        <Container fluid className="px-0">
          <div className="ticker-container">
            <div className="ticker-label">{t("latest")}</div>
            <Marquee speed={60} pauseOnHover={true}>
              {marqueeData.map((data, i) => (
                <span key={i} className="ticker-msg">{data.body} <span className="sep">◆</span></span>
              ))}
            </Marquee>
          </div>
        </Container>
      </div>

      <StickyMenu />
      <MobileMenu />

      <Modal centered show={getAnnouncmentModal} onHide={() => setAnnouncementModal(false)} className="modern-modal">
        <Modal.Header closeButton>
          <Modal.Title>{announcementData1.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{ReactHtmlParser(announcementData1.body)}</Modal.Body>
        <Modal.Footer>
          <small>{announcementData1.date}</small>
          <Button variant="secondary" onClick={() => setAnnouncementModal(false)}>{t("close")}</Button>
        </Modal.Footer>
      </Modal>
    </Styles>
  );
}

export default HeaderTNP;